var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('rabbey-table-3',{attrs:{"loading":_vm.loading,"columns":_vm.columns,"data":_vm.items,"paginate-from-api":true,"pagination-api":_vm.pagination},on:{"update-current-page":_vm.onCurrentChange,"update-page-size":_vm.onSizeChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }